var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Book, Open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9346",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7497",
    d: "M17 5.317a20.419 20.419 0 012.956-.3 1 1 0 011.044 1v11.836a1 1 0 01-.974 1A15.041 15.041 0 0012 21a15.031 15.031 0 00-8.026-2.148 1 1 0 01-.974-1V6.016a1 1 0 011.017-1A16.166 16.166 0 0112 7.146"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7498",
    d: "M17 15.238V3.012a1 1 0 00-1.417-.912A6.819 6.819 0 0012 6.612V21a6.825 6.825 0 014.331-4.824.987.987 0 00.669-.938z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7499",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgBookOpen;


//////////////////
// WEBPACK FOOTER
// ./src/icons/BookOpen.svg
// module id = 880
// module chunks = 101